const topics = [
  { name: '悬疑烧脑', heat: '9.8w', icon: 'ri-mind-map', trending: true },
  { name: '古装仙侠', heat: '8.5w', icon: 'ri-sword-line', trending: true },
  { name: '都市情感', heat: '7.2w', icon: 'ri-heart-line', trending: false },
  { name: '韩剧热播', heat: '9.1w', icon: 'ri-hearts-line', trending: true },
  { name: '美剧精选', heat: '6.8w', icon: 'ri-global-line', trending: false },
  { name: '国产良心', heat: '8.9w', icon: 'ri-flag-2-line', trending: true },
  { name: '日剧经典', heat: '5.4w', icon: 'ri-sun-line', trending: false },
  { name: '热门综艺', heat: '7.6w', icon: 'ri-tv-line', trending: false },
  { name: '动漫番剧', heat: '8.3w', icon: 'ri-rocket-line', trending: true },
  { name: '纪录大片', heat: '4.7w', icon: 'ri-film-line', trending: false },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-2">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8">
          探索当下最火热的追剧话题，找到你的下一部心头好
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.name}
              className="group relative inline-flex items-center gap-2.5 px-5 py-3 bg-background-50 border border-background-200 rounded-full cursor-pointer hover:border-primary-300 hover:shadow-sm transition-all duration-200"
            >
              {topic.trending && (
                <span className="absolute -top-1.5 -right-1.5 w-5 h-5 flex items-center justify-center bg-primary-500 rounded-full">
                  <i className="ri-arrow-up-line text-[10px] text-background-50"></i>
                </span>
              )}
              <span className="w-7 h-7 flex items-center justify-center bg-accent-100 text-accent-600 rounded-full text-sm">
                <i className={`${topic.icon}`}></i>
              </span>
              <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">{topic.name}</span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{topic.heat}热度</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}